export default __webpack_public_path__ + "static/media/Girdle of the Ubah Kan.123f0b47.jpg";